var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoryDefect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8 2.5c-.82843 0-1.5.67157-1.5 1.5h3c0-.82843-.67157-1.5-1.5-1.5zm3 1.52074v-.02074c0-1.65685-1.34315-3-3-3s-3 1.34315-3 3v.02074c-.29048.04873-.55266.18096-.761.37115l-.88669-.63334-.91695-2.06315-1.37072.6092.94464 2.12544c.09062.20389.23416.37981.41572.50949l1.325.94643v1.11404h-3.25v1.5h3.25v1.14872l-1.14979.95818c-.13248.1104-.24068.247-.3178.4012l-1.20323 2.4065 1.34164.6708 1.17984-2.3597.46058-.3838c.63558 1.5764 2.17703 2.6581 3.94022 2.6581h.24854c1.71908 0 3.1849-1.0844 3.7506-2.6066l.3987.3323 1.1799 2.3597 1.3416-.6708-1.2032-2.4065c-.0771-.1542-.1853-.2908-.3178-.4012l-1.1498-.95818v-1.14872h3.25v-1.5h-3.25v-1.11404l1.325-.94643c.1816-.12968.3251-.3056.4157-.50949l.9447-2.12544-1.3708-.6092-.9169 2.06315-.8867.63334c-.2083-.19019-.4705-.32242-.761-.37115zm-.25 5.97926v-4.5h-5.5v4.44265l.03488.22675c.20629 1.3408 1.35998 2.3306 2.71658 2.3306h.24854c1.38071 0 2.5-1.1193 2.5-2.5z",
    fill: "#f15b50",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryDefect);
export default __webpack_public_path__ + "static/media/story-defect.aae6bc2035f62d66f9a745eb339cb228.svg";
export { ForwardRef as ReactComponent };